import { FlexRowBetween, LoaderBar, PageHeader } from 'components'
import { Form, Tab } from 'semantic-ui-react'
import { useMemo, useState } from 'react'
import {
    GetReport,
    GetStatusList,
    GetUserList,
    GetCompanyTemplateList,
    GetCustomerList,
    GetCheckInReport,
    GetUserListForGroup,
    useCustomerGroups,
    GetExternalCustomerList,
} from 'hooks'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import {
    FormCheckBoxField,
    FormDateField,
    FormDropdownField,
    // FormTextFormField,
    SubmitCancelButtons,
} from 'elements'
import {
    // ReportChart,
    ReportDataTable,
    // ReportChartWitoutScore,
    // ReportChartByNC,
    CheckInReportDataTable,
    CheckInReportChart,
    DownloadIcon,
} from 'page-components'
import {
    AuthService,
    ChartUtility,
    DateFormat,
    DatePickerTypes,
    DateUtility,
    TemplateService,
} from 'utility'
import { useNavigate } from 'react-router-dom'

const ReportSchema = yup.object().shape({
    StartDate: yup
        .string()
        .required('Start date required')
        .typeError('Start date required'),
    EndDate: yup
        .string()
        .required('End date required')
        .typeError('End date required'),
    Status: yup.string(),
    UserId: yup.array().min(0).nullable(),
    CustomerIds: yup.array().min(0).nullable(),
    ExternalCustomerIds: yup.array().min(0).nullable(),
    TemplateId: yup.string(),
    GroupId: yup.string().nullable(),
    ShowExecutiveReport: yup.boolean(),
})

const EXECUTIVE_REPORT_COMPANY_ID = 47464

export const ReportScreen = () => {
    const {
        data,
        loading,
        filterChanged,
        filter,
        totalCount,
        setData,
        refresh,
        outputFile,
        pagination,
        pageChanged,
    } = GetReport()
    const { options: statusOptions } = GetStatusList()
    const { options: userOptions } = GetUserList()
    const { options: templateOptions } = GetCompanyTemplateList()
    const { options: customerList } = GetCustomerList()
    const { options: externalCustomerList } = GetExternalCustomerList()
    // Group options from customer groups
    const companyId = AuthService.getUser()?.Companies?.[0]?.CompanyId
    const showExecutiveReportOption =
        Number(companyId) === EXECUTIVE_REPORT_COMPANY_ID
    const customerGroups = useCustomerGroups(companyId)
    const groupOptions = useMemo(
        () =>
            (customerGroups || []).map(g => ({
                value: g.CustomerGroupId,
                text: g.CustomerGroupName,
            })),
        [customerGroups],
    )
    const naviagate = useNavigate()
    const [processing, setProcessing] = useState('')
    const groupedByTemplate = useMemo(
        () => ChartUtility.groupByTemplate(data || []),
        [data],
    )

    console.log(AuthService.getUser().unique_id, "userrrrrr");

    const chartdata = useMemo(
        () =>
            groupedByTemplate.map(ele => ({
                name: ele?.[0].TemplateData?.AuditName,
                filters: [
                    {
                        text: 'All',
                        value: 0,
                        list: ChartUtility.getGroupedForChart(ele || []),
                        withoutScoreList: ChartUtility.getGroupedForChart(
                            ele || [],
                        ),
                    },
                    ...ele.map(item => ({
                        text: `${item.CreatedByName}${item.CompletedOn ? ' - ' : ''
                            }${item.CompletedOn
                                ? DateUtility.dateToLocalISO(
                                    new Date(item.CompletedOn),
                                    DateFormat.dateTime,
                                )
                                : ''
                            }`,
                        value: item.AuditUniqueId,
                        reportLink: item.ReportLink,
                        list: Object.values(
                            ChartUtility.getSectionResult(
                                item.TemplateData.Sections,
                            ),
                        ),
                        withoutScoreList: Object.values(
                            ChartUtility.withoutScoreDataResult(
                                item.TemplateData.Sections,
                            ),
                        ),
                    })),
                ],
                list: ChartUtility.getGroupedForChart(ele || []),
            })),
        [groupedByTemplate],
    )
    const {
        control,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(ReportSchema),
        defaultValues: {
            StartDate: new Date(),
            EndDate: new Date(),
            Target: 95,
            GroupId: '',
            ShowExecutiveReport: false,
        },
    })
    const Target = watch('Target')
    const StartDate = watch('StartDate')

    const submit = formData => {
        filterChanged({
            StartDate: DateUtility.dateToLocalISO(
                DateUtility.startDay(new Date(formData.StartDate)),
            ),
            EndDate: DateUtility.dateToLocalISO(
                DateUtility.endDay(new Date(formData.EndDate)),
            ),
            Status: formData.Status || undefined,
            TemplateId: formData.TemplateId || undefined,
            GroupId: formData.GroupId || undefined,
            UserId: formData.UserId?.length
                ? formData.UserId?.toString()?.replaceAll(',', ';')
                : undefined,
            customerIds: formData.CustomerIds?.length
                ? formData.CustomerIds?.toString()?.replaceAll(',', ';')
                : undefined,
            ...(companyId === 34930 && {
                ExternalCustomerIds: formData.ExternalCustomerIds?.length
                    ? formData.ExternalCustomerIds?.toString()?.replaceAll(',', ';')
                    : undefined,
            }),
            ...(showExecutiveReportOption && {
                ShowExecutiveReport: !!formData.ShowExecutiveReport,
            }),
        })
    }
    const resetForm = async () => {
        reset({
            StartDate: new Date(),
            EndDate: new Date(),
            UserId: undefined,
            Target: 95,
            GroupId: '',
            ShowExecutiveReport: false,
        })
        setData([])
        setProcessing('')
    }

    const onReopen = async item => {
        const user = AuthService.getUser()
        const isActionHandler = user?.CanCreateActionPlan === true
        if (isActionHandler) {
            setProcessing('Creating Action Plan')
            try {
                naviagate(`/app/templates/inspection/${item.AuditUniqueId}`, {
                    state: { isActionPlan: true },
                })
            } catch (error) {
                console.error('Error creating action plan:', error)
            } finally {
                setProcessing('')
            }
        } else {
            setProcessing('Reopening')
            try {
                await TemplateService.reopenReport({
                    TemplateId: item.AuditUniqueId,
                    statusId: 6,
                })
                naviagate(`/app/templates/inspection/${item.AuditUniqueId}`)
                refresh()
            } catch (error) {
                console.error('Error reopening report:', error)
            } finally {
                setProcessing('')
            }
        }
    }

    const panes = useMemo(() => {
        // const showNCReport = AuthService.showNCReport()
        const temp = [
            {
                menuItem: 'Data',
                render: () => (
                    <ReportDataTable
                        data={data}
                        filter={filter}
                        filterChanged={filterChanged}
                        onReopen={onReopen}
                        totalCount={totalCount}
                        loading={loading}
                        outputFile={outputFile}
                        pagination={pagination}
                        pageChanged={pageChanged}
                    />
                ),
            },
        ]

        // if (showNCReport) {
        //     temp.push({
        //         menuItem: 'Chart (By NC)',
        //         render: () => (
        //             <ReportChartByNC data={chartdata || []} loading={loading} />
        //         ),
        //     })
        // } else {
        //     temp.push(
        //         ...[
        //             // {
        //             //     menuItem: 'Chart (By Score)',
        //             //     render: () => (
        //             //         <ReportChart
        //             //             data={chartdata || []}
        //             //             target={Target}
        //             //             loading={loading}
        //             //         />
        //             //     ),
        //             // },
        //             {
        //                 menuItem: 'Chart (Without Score)',
        //                 render: () => (
        //                     <ReportChartWitoutScore
        //                         data={chartdata || []}
        //                         target={Target}
        //                         loading={loading}
        //                     />
        //                 ),
        //             },
        //         ],
        //     )
        // }
        return temp
    }, [data, chartdata, Target, loading, pagination])

    return (
        <>
            <div className="">
                <PageHeader header="Inspection Report" />
                <Form noValidate>
                    <Form.Group widths="equal">
                        <FormDateField
                            name="StartDate"
                            control={control}
                            label="Start Date"
                            errors={errors.StartDate}
                            type={DatePickerTypes.Single}
                        />
                        <FormDateField
                            name="EndDate"
                            control={control}
                            label="End Date"
                            disabledBefore={StartDate}
                            errors={errors.EndDate}
                            type={DatePickerTypes.Single}
                        />
                        <FormDropdownField
                            control={control}
                            name="Status"
                            label="Status"
                            errors={errors.Status}
                            options={statusOptions}
                            placeholder="Select Status"
                            defaultValue=""
                        />
                        {/* <FormTextFormField
                            control={control}
                            name="Target"
                            label="Target (%)"
                            errors={errors.Target}
                            defaultValue=""
                        /> */}
                    </Form.Group>
                    <Form.Group widths="equal">
                        <FormDropdownField
                            control={control}
                            placeholder="Select User"
                            name="UserId"
                            label="User"
                            errors={errors.UserId}
                            options={userOptions}
                            defaultValue={[]}
                            multiple
                        />
                        {companyId !== 34930 && (
                            <FormDropdownField
                                control={control}
                                name="GroupId"
                                label="Group"
                                placeholder="Select Group"
                                errors={errors.GroupId}
                                options={groupOptions}
                                defaultValue=""
                            />
                        )}
                        {
                            companyId === 34930 ? (
                                <FormDropdownField
                                    control={control}
                                    name="ExternalCustomerIds"
                                    label="External Customer"
                                    placeholder="Select Customers"
                                    errors={errors.ExternalCustomerIds}
                                    options={externalCustomerList}
                                    defaultValue={[]}
                                    multiple
                                />
                            ) : (
                                <FormDropdownField
                                    control={control}
                                    name="CustomerIds"
                                    label="Customers"
                                    errors={errors.CustomerIds}
                                    options={customerList}
                                    defaultValue={[]}
                                    placeholder="Select Customers"
                                    multiple
                                />
                            )
                        }

                        <FormDropdownField
                            control={control}
                            name="TemplateId"
                            label="Template"
                            placeholder="Select Template"
                            errors={errors.TemplateId}
                            options={templateOptions}
                            defaultValue=""
                        />
                    </Form.Group>
                    {showExecutiveReportOption && (
                        <Form.Field className="mb-2">
                            <FormCheckBoxField
                                control={control}
                                name="ShowExecutiveReport"
                                label="Show Executive Report"
                                defaultValue={false}
                            />
                        </Form.Field>
                    )}
                    <div className="pt-1">
                        <SubmitCancelButtons
                            onSubmit={handleSubmit(submit)}
                            onCancel={resetForm}
                            className=""
                        />
                    </div>
                </Form>
            </div>
            <div>
                {outputFile && (
                    <FlexRowBetween className="mt-3 justify-content-end">
                        <DownloadIcon outputFile={outputFile} />
                    </FlexRowBetween>
                )}
            </div>
            <div className="my-3">
                <Tab panes={panes} menu={{ secondary: true, pointing: true }} />
                {(processing || loading) && (
                    <LoaderBar content={processing || 'Loading'} />
                )}
            </div>
        </>
    )
}

const CheckInReportSchema = yup.object().shape({
    StartDate: yup
        .string()
        .required('Start date required')
        .typeError('Start date required'),
    EndDate: yup
        .string()
        .required('End date required')
        .typeError('End date required'),
    UserId: yup.string().nullable(),
})

export const CheckReportScreen = () => {
    const { data, loading, filterChanged, totalCount, refresh, pageChanged } =
        GetCheckInReport()
    const { options: userOptions } = GetUserListForGroup()
    const {
        control,
        handleSubmit,
        reset,
        watch,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(CheckInReportSchema),
        defaultValues: {
            StartDate: new Date(),
            EndDate: new Date(),
            UserId: null,
        },
    })

    const StartDate = watch('StartDate')

    const submit = formData => {
        filterChanged({
            StartDate: DateUtility.dateToLocalISO(
                DateUtility.startDay(new Date(formData.StartDate)),
            ),
            EndDate: DateUtility.dateToLocalISO(
                DateUtility.endDay(new Date(formData.EndDate)),
            ),
            UserId: formData.UserId || undefined,
        })
    }

    const resetForm = () => {
        reset({
            StartDate: new Date(),
            EndDate: new Date(),
            UserId: null,
        })
        refresh()
    }

    const panes = useMemo(
        () => [
            {
                menuItem: 'Data',
                render: () => (
                    <CheckInReportDataTable
                        data={data}
                        totalCount={totalCount}
                        loading={loading}
                        pageChanged={pageChanged}
                    />
                ),
            },
            {
                menuItem: 'Chart',
                render: () => (
                    <CheckInReportChart data={data} loading={loading} />
                ),
            },
        ],
        [data, loading, totalCount],
    )

    return (
        <>
            <div>
                <PageHeader header="Check-In Report" />
                <Form noValidate>
                    <Form.Group widths="equal">
                        <FormDateField
                            name="StartDate"
                            control={control}
                            label="Start Date"
                            errors={errors.StartDate}
                            type={DatePickerTypes.Single}
                        />
                        <FormDateField
                            name="EndDate"
                            control={control}
                            label="End Date"
                            disabledBefore={StartDate}
                            errors={errors.EndDate}
                            type={DatePickerTypes.Single}
                        />
                        <FormDropdownField
                            name="UserId"
                            control={control}
                            label="User"
                            placeholder="Select User"
                            options={userOptions}
                            errors={errors.UserId}
                        />
                    </Form.Group>
                    <div className="pt-1">
                        <SubmitCancelButtons
                            onSubmit={handleSubmit(submit)}
                            onCancel={resetForm}
                        />
                    </div>
                </Form>
            </div>
            <div className="my-3">
                <Tab panes={panes} menu={{ secondary: true, pointing: true }} />
                {loading && <LoaderBar content="Loading..." />}
            </div>
        </>
    )
}
